import { combineReducers } from 'redux'
import { reducer as notifications } from 'react-notification-system-redux'
import locationReducer from './location'
import mapReducer from '../routes/Map/modules/map'
import databaseReducer from '../routes/Database/modules/database'
import aboutReducer from '../routes/About/modules/about'
import consortiumReducer from '../routes/Consortium/modules/consortium'
import mainmenuReducer from '../layouts/Layout/MainMenu/module/mainmenu'
import articlesReducer from './articles'
import loginReducer from '../components/AdminPanel/module/login'
import newsletterReducer from './newsletter'
import keywordReducer from './keyword'
import actorReducer from './actor'
import fieldReducer from './field'
import trainingReducer from './training'
import stakeholderReducer from './stakeholder'
import chartReducer from './charts'
import voteReducer from './vote'
import ipReducer from './ip'
import inequalityReducer from './inequality'
import socialmediaReducer from './socialmedia'

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    notifications,
    location: locationReducer,
    map: mapReducer,
    login: loginReducer,
    database: databaseReducer,
    about: aboutReducer,
    mainmenu: mainmenuReducer,
    articles: articlesReducer,
    newsletter: newsletterReducer,
    keyword: keywordReducer,
    actor: actorReducer,
    field: fieldReducer,
    consortium: consortiumReducer,
    training: trainingReducer,
    stakeholder: stakeholderReducer,
    inequality: inequalityReducer,
    chart: chartReducer,
    vote: voteReducer,
    ip: ipReducer,
    socialmedia: socialmediaReducer,
    ...asyncReducers
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js